export default __webpack_public_path__ + "static/media/features-thumb-4.1617652d.png";